export const thankYouPages = {
  development: {
    degree: {
      ucb: {
        data: '/degree/ucb/thankyou-data'
      },
      unc: {
        mba: '/degree/unc/thankyou-mba'
      },
      den: {
        sw: '/degree/den/thankyou-sw'
      },
      nyu: {
        counseling: '/degree/nyu/thankyou-counseling'
      },
      nu: {
        counseling: '/degree/nu/thankyou-counseling',
        'counseling-mac': '/degree/nu/thankyou-counseling-mac'
      }
    }
  },
  production: {
    degree: {
      ucb: {
        data: '/requestinfo/thank-you-mids'
      },
      unc: {
        mba: '/requestinfo/thank-you-mba'
      },
      den: {
        sw: '/requestinfo/thank-you'
      },
      nyu: {
        counseling: '/requestinfo/thank-you-mhc'
      },
      nu: {
        counseling: '/requestinfo/thank-you-mac-mft',
        'counseling-mac': '/requestinfo/thank-you-mac'
      }
    }
  }
};
